import NamedDto from 'modules/base/dto/NamedDto';

export class SimulationMonitorFieldEditDto extends NamedDto {
	constructor() {
		super();

		/** @type {string} */
		this.type = null;

		/** @type {number} */
		this.sigma = null;
	}

	/**
	 * @typedef {Object} _SimulationMonitorFieldEditDtoProps
	 * @property {string} type
	 * @property {number} sigma
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _SimulationMonitorFieldEditDtoProps} SimulationMonitorFieldEditDtoProps
	 */
	/**
	 *
	 * @param {SimulationMonitorFieldEditDtoProps} props
	 * @returns {SimulationMonitorFieldEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.type = props.type;
		this.sigma = props.sigma;

		return this;
	}
}

export default SimulationMonitorFieldEditDto;